function init_allocation_and_alerts () {
	
    addAccountOverview();

	$.ajaxSetup({cache: false});
	$.when(
	        $.get(templatesDir+'/accounttemplates.html', function (templates) {
	            globalStore.accountTemplate = templates;
	        })
	).then(function () {
	    setupMustache(globalStore);
	});


}